export function camelToKebab(s) {
    return s.split(/([A-Z]+)/).map((p, i, a) => i % 2 ? ((a[i - 1] ? '-' : '') +
        (p.length > 1 && a[i + 1] ? p.slice(0, -1) + '-' + p.slice(-1) : p).toLowerCase()) : p).join('');
}
function flattenTo(arr, to) {
    for (let i = 0, l = arr.length; i < l; i++) {
        if (Array.isArray(arr[i]))
            flattenTo(arr[i], to);
        else
            to.push(arr[i]);
    }
}
export function flatten(arr) {
    if (!Array.isArray(arr))
        return [arr];
    const out = [];
    flattenTo(arr, out);
    return out;
}
//# sourceMappingURL=util.mjs.map